import p1_img from './acer.jpg'
import p2_img from './ass1.jpg'
import p3_img from './ass2.jpg'
import p4_img from './ass3.jpg'


let new_collection = [
    {
        id:1,
        name:'Acer Laptop',
        image:p1_img,
        new_price:'300,000.00',
        old_price:'100,000.00',

    },
    {
        id:2,
        name:'16Gig Memory chip',
        image:p2_img,
        new_price:'25,000.00',
        old_price:'10,000.00',

    },
    {
        id:3,
        name:'Wireless Mouse',
       
        image:p3_img,
        new_price:'25,000.00',
        old_price:'10,000.00',

    },
    {
        id:4,
        name:'16Gig Flash',
        image:p4_img,
        new_price:'30,000.00',
        old_price:'10,000.00',

    },
];

export default new_collection;